import { ManagedRuntime } from 'effect';

import { ZoneLayer } from './layers/CommonLayer';

export const RuntimeDate = ManagedRuntime.make(ZoneLayer);
